export const HomeMenuIcon = ({ width = 32, height = 32 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <path d="M3 9.5L12 2.5L21 9.5V20.5C21 21.0304 20.7893 21.5391 20.4142 21.9142C20.0391 22.2893 19.5304 22.5 19 22.5H5C4.46957 22.5 3.96086 22.2893 3.58579 21.9142C3.21071 21.5391 3 21.0304 3 20.5V9.5Z" stroke="url(#paint0_linear_19054_38256)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9 22.5V12.5H15V22.5" stroke="url(#paint1_linear_19054_38256)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <defs>
      <linearGradient id="paint0_linear_19054_38256" x1="3" y1="12.5007" x2="21.0009" y2="12.5007" gradientUnits="userSpaceOnUse">
        <stop stop-color="#000"/>
        <stop offset="1" stop-color="#000"/>
      </linearGradient>
      <linearGradient id="paint1_linear_19054_38256" x1="9" y1="17.5003" x2="15.0003" y2="17.5003" gradientUnits="userSpaceOnUse">
        <stop stop-color="#000"/>
        <stop offset="1" stop-color="#000"/>
      </linearGradient>
    </defs>
  </svg>
);
